const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;

export const CheckToken = async (Token, setModal) => {
    const url = `${API_Payment_URL}Account/CheckToken`;
    const data = {
      Token: Token,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        setModal(true);
        return errorDetails;
      }

      const result = await response.json();
      setModal(false);

      return result;
    } catch (error) {
        setModal(true);
      console.error("Error", error);
    }
  };